<agr-page-toolbar
  [isEmpty]="(cycle$ | async)?.movements.length === 0"
  [emptyTitle]="'movement.no-movements-title' | translate"
  [emptyDescription]="'movement.no-movements-description' | translate"
  emptyImage="assets/images/arrival.jpg"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="addDialog()"
  data-test="movement-overview"
>
  <ng-container *ngIf="(isLoading$ | async) === false && cycle$ | async as cycle">
    <mat-nav-list role="list" *ngIf="cycle?.movements?.length" class="movement-overview__list">
      <a
        mat-list-item
        *ngFor="let movement of sort(cycle.movements); let last = last"
        role="listitem"
        class="movement-item"
        [attr.data-test]="'movement-overview__item_' + movement.id"
        (click)="openMovementEdit(movement.id, last)"
      >
        <mat-icon
          matListItemIcon
          matListItemAvatar
          class="list-avatar"
          svgIcon="mdi-walk"
        ></mat-icon>
        <div matListItemTitle>
          {{ movement?.fromSection?.name }} ({{ movement?.fromSection?.barn?.name }}) |
          {{ movement?.fromPropagationCompany?.name }} &rarr; {{ movement?.toSection?.name }} ({{
            movement?.toSection?.barn?.name
          }}) | {{ movement?.toPropagationCompany?.name }}
        </div>
        <div matListItemLine class="text--gray">
          {{ movement.numberOfAnimals | agrNumber }}
          {{ movement.fromSection.gender | translate | lowercase }} ({{
            movement.fromSection.breed?.name
          }})
        </div>
        <div matListItemLine class="text--gray" *ngIf="movement.movementDate">
          {{ movement.movementDate | date }}
        </div>
        <button
          matListItemMeta
          mat-icon-button
          *ngIf="last"
          (click)="delete($event, movement)"
          data-test="movement-overview__delete-item"
        >
          <mat-icon iconPositionEnd>delete</mat-icon>
        </button>
      </a>
      <mat-divider *ngIf="cycle.movements.length > 0"> </mat-divider>
      <agr-extended-notification
        notificationType="info"
        [title]="'movement.overview-info-title' | translate"
        [message]="'movement.overview-info-message' | translate"
      >
      </agr-extended-notification>
    </mat-nav-list>
  </ng-container>
</agr-page-toolbar>
